import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import {
  ApiService,
  AuthService,
  EnvironmentService,
  HttpRequestService,
  LogService,
  NotificationService,
  PagedResultGeneric,
  UtilService,
} from 'src/app/shared';
import { ServiceApiService } from 'src/app/shared/api/service-api.service';
import { EComItemTypeCustomFieldDto } from './dto/ecom-item-type-custom-field.dto';
import { EcomItemTypeSearchDto } from './dto/ecom-item-type-search.dto';
import { EcomItemTypeDto } from './dto/ecom-item-type.dto';

@Injectable({
  providedIn: 'root',
})
export class EcomItemTypeService extends ServiceApiService {
  private _ecomItemTypes = new Subject<EcomItemTypeDto[]>();
  private ecomItemTypes = this._ecomItemTypes.asObservable();

  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService, 'eCommerce');
  }

  public subscribeToEcomItemTypes$() {
    return this.ecomItemTypes;
  }

  public initializeEcomItemSubscription() {
    this.search({ PageNumber: 0 } as EcomItemTypeSearchDto).then((results) => {
      this._ecomItemTypes.next(results.Result);
    });
  }

  public search(searchDto: EcomItemTypeSearchDto): Promise<PagedResultGeneric<EcomItemTypeDto>> {
    let url = `ecommerce/v2/itemtypes`;
    return this.post(url, searchDto);
  }

  public getEcomItemType(id: number, forceRefresh?: boolean): Promise<EcomItemTypeDto> {
    const cacheOptions = forceRefresh ? this.getDefaultApiCacheOptionsForNoCache() : null;
    let url = `ecommerce/v2/itemtype/${id}`;
    return this.get(url, cacheOptions);
  }

  createItemType(dto: EcomItemTypeDto): Promise<number> {
    return this.post('ecommerce/v2/itemtype', dto);
  }

  updateItemType(dto: EcomItemTypeDto): Promise<void> {
    return this.put(`ecommerce/v2/itemtype`, dto);
  }

  public deleteEcomItemTypeCustomField(id: number): Promise<void> {
    let url = `ecommerce/v2/itemtype/${id}`;
    return this.delete(url);
  }
}
